import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import block from '../../asset/images/block.svg'
import arrowup from '../../asset/images/arrowup.svg'
import arrowdown from "../../asset/images/arrowdown.svg"
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { AESEncryption, allTrim, ApiResDecrypt, handleDownloadDocument } from '../../CommonMethhods/CommonMethods';
import { CommonDate } from '../../CommonMethhods/DateFunction';
import check from "../../asset/images/check.svg"
import axios from 'axios';
import { Hni_Admin_Api } from '../../Configuration/API_URL';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
// import { format } from 'date-fns';
import Loader from '../../Components/Common/Loader';

const SocialMediaBrokerage = () => {
  const [brokrageValue, setBrokrageValue] = useState({})
  const [loader, setLoader] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const schemaFilter = Yup.object().shape({
    fromDate: Yup.string().required("Enter From Date"),
    toDate: Yup.string().required("Enter To Date"),
  });
  const { register: regesterFilter, handleSubmit: handleFilterSubmit, formState: { errors: filterErrors }, setValue: setFilterValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(schemaFilter),
  });
  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  //   const offset = (pageNumber - 1) * itemsPerPage; // Calculate offset
  //   listofhnipackdetail({ duration: selectedOption, offset, limit: itemsPerPage });

  // };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

    const offset = (pageNumber - 1) * itemsPerPage; // Calculate the new offset

    if (selectedOption === "CUSTOM") {
      // Ensure fromDate and toDate are fetched from filterDate
      const { fromDate = "", toDate = "" } = filterDate || {};

      searchPackdetail({
        duration: "CUSTOM",
        fromDate,
        toDate,
        offset,
        limit: itemsPerPage
      });
    } else {
      listofhnipackdetail({ duration: selectedOption, offset, limit: itemsPerPage });
    }
  };

  const handleItemsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setItemsPerPage(newLimit);
    setCurrentPage(1); // Reset to the first page

    // Use filterDate values or fallback to empty strings
    const { fromDate = "", toDate = "" } = filterDate || {};

    if (selectedOption === "CUSTOM") {
      searchPackdetail({
        duration: "CUSTOM",
        fromDate,
        toDate,
        offset: 0,
        limit: newLimit
      });
    } else {
      listofhnipackdetail({ duration: selectedOption, offset: 0, limit: newLimit });
    }
  };

  const filterApplication = async (data) => {
    listofhnipackdetail(data);
  };
  useEffect(() => {
    listofhnipackdetail({ duration: selectedOption });
  }, []);
  const [filterModal, setFilterModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("CY");
  const [customDates, setCustomDates] = useState({ fromDate: "", toDate: "" });
  const [hnipackList, setHnipackList] = useState([]);

  const listofhnipackdetail = async (data) => {
    setLoader(true)
    const payload = {
      format: "grid",
      duration: data.duration || "CUSTOM",
      fromDate: data.fromDate || "",
      toDate: data.toDate || "",
      offset: data.offset || 0,
      limit: data.limit || itemsPerPage,
    };
    console.log(payload, "payload");
    let encPayload = AESEncryption(payload);

    try {
      const response = await axios.post(
        `${Hni_Admin_Api.listofhnipackdetail}`,
        encPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );

      // console.log("API Response:", response.data.data);
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      if (storeResponse.status === 0) {
        console.log(storeResponse.data.hniPackList);

        setHnipackList(storeResponse.data.hniPackList);
        setTotalCount(storeResponse.data.totalCount);
        setFilterModal(false);
      } else {
        toast.error(storeResponse.message);
        setHnipackList([])
      }
    } catch (err) {
      // console.error("Error fetching HNI pack details", err);
      // toast.error("Failed to fetch data.");
      toast.error("Something Went Wrong")
      setHnipackList([])
    } finally {
      setLoader(false)

    }
  };
  const handleCustomDateChange = (e) => {
    const { name, value } = e.target;
    setCustomDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [filterDate, setFilterdate] = useState({ fromDate: "", toDate: "" })
  const handleCustomSubmit = (e) => {
    e.preventDefault();

    const { fromDate, toDate } = customDates;

    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date.");
      return;
    }

    const formattedFromDate = fromDate.replace(/-/g, "");
    const formattedToDate = toDate.replace(/-/g, "");
    setFilterdate({ fromDate: formattedFromDate, toDate: formattedToDate })
    console.log(`From Date: ${formattedFromDate}, To Date: ${formattedToDate}`);
    // searchPackdetail({
    //   duration: "CUSTOM",
    //   fromDate: formattedFromDate,
    //   toDate: formattedToDate,
    // })
    searchPackdetail({
      duration: "CUSTOM",
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      offset: 0,
      limit: itemsPerPage,
    });
  };
  const searchPackdetail = async (data) => {
    setLoader(true)
    const payload = {
      format: "grid",
      duration: "CUSTOM",
      fromDate: data.fromDate,
      toDate: data.toDate,
      offset: data.offset || 0,
      limit: data.limit || itemsPerPage,
    };
    console.log(payload, "payload");
    let encPayload = AESEncryption(payload);
    try {
      const response = await axios.post(
        `${Hni_Admin_Api.listofhnipackdetail}`,
        encPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );

      // console.log("API Response:", response.data.data);
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      if (storeResponse.status === 0) {
        console.log(storeResponse.data.hniPackList);
        setHnipackList(storeResponse.data.hniPackList);
        setTotalCount(storeResponse.data.totalCount);
        setFilterModal(false)
        return
      } else {
        toast.error(storeResponse.message);
        setHnipackList([])
      }
    } catch (err) {
      setHnipackList([])
      // console.error("Error fetching HNI pack details", err);
      // toast.error("Failed to fetch data.");
      toast.error("Something Went Wrong")
    } finally {
      setLoader(false)
    }
  };
  const download = async (event) => {
    console.log(event, "event");
    console.log(filterDate, "filterDate");
    let payload = null;
    if (event === "a" && selectedOption == "CY") {
      payload = {
        format: "excel",
        duration: selectedOption,
        fromDate: "",
        toDate: "",
        offset: -1,
        limit: 10,
      };
    }
    if (event === "a" && selectedOption == "TD") {
      payload = {
        format: "excel",
        duration: selectedOption,
        fromDate: "",
        toDate: "",
        offset: -1,
        limit: 10,
      };
    }
    if (event === "a" && selectedOption == "CW") {
      payload = {
        format: "excel",
        duration: selectedOption,
        fromDate: "",
        toDate: "",
        offset: -1,
        limit: 10,
      };
    }
    if (event === "a" && selectedOption == "CM") {
      payload = {
        format: "excel",
        duration: selectedOption,
        fromDate: "",
        toDate: "",
        offset: -1,
        limit: 10,
      };
    }
    if (event === "a" && selectedOption == "CUSTOM") {
      payload = {
        format: "excel",
        duration: selectedOption,
        fromDate: filterDate.fromDate,
        toDate: filterDate.toDate,
        offset: -1,
        limit: 10,
      };
    }
    // else if (event === "CUSTOM") {
    //   const { fromDate, toDate } = customDates;

    //   if (!fromDate || !toDate) {
    //     toast.error("Please select both From Date and To Date.");
    //     return;
    //   }
    //   const formattedFromDate = fromDate.replace(/-/g, "");
    //   const formattedToDate = toDate.replace(/-/g, "");
    //   console.log(filterDate, "filterDate");

    //   payload = {
    //     format: "excel",
    //     duration: "CUSTOM",
    //     fromDate: formattedFromDate,
    //     toDate: formattedToDate,
    //     offset: 0,
    //     limit: 10,
    //   };
    // } 
    else {
      console.log("error");
    }
    console.log(payload, "payload");
    let encPayload = AESEncryption(payload);
    try {
      const response = await axios.post(
        `${Hni_Admin_Api.listofhnipackdetail}`,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
          // responseType: "blob",
        }
      );
      // debugger
      const data = await response;
      console.log(data.data, "urldata");

      let storeResponse = ApiResDecrypt(data.data);
      console.log(storeResponse, "urldata");
      if (storeResponse.status == 0) {
        handleDownloadDocument(storeResponse.data)
      } else {
        console.log("error");

      }

    } catch (err) {
      // console.error("Error downloading Excel", err);
      // toast.error("Failed to download Excel file.");
      toast.error("Something Went Wrong")
    }
  };



  const handleDeactivate = (rowData) => {
    console.log("Deactivating row:", rowData, rowData.refId);
    deactivate(rowData)
  };


  const deactivate = async (rowData) => {
    let payload = {
      "refId": rowData.refId
    };
    let encPayload = AESEncryption(payload);
    try {
      const response = await axios.post(
        `${Hni_Admin_Api.deactivatehnipackdetail}`,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1
          },
        }
      );
      // console.log(response.data, "response");
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      if (storeResponse.status == 0) {
        toast.success(storeResponse.data)
        if (storeResponse.data == "Pack detail deactivated successfully") {
          handleDateChange({ target: { value: selectedOption } });
          if (selectedOption == "CUSTOM") {
            console.log(filterDate, "filterDate");
            setFilterModal(false)
            searchPackdetail(filterDate)
          }
        }
      } else {
        toast.error(storeResponse.message)
      }

    } catch (err) {
      toast.error("Something Went Wrong")
    } finally {
    }
  }
  const handleDateChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    if (selectedValue !== "CUSTOM") {
      // console.log(selectedValue,selectedOption,"selectedOption");
      listofhnipackdetail({ duration: selectedValue });
    } else {
      setFilterModal(true)
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    gethnipackdetails()
  }, [])

  const gethnipackdetails = async () => {
    try {
      const response = await axios.get(
        `${Hni_Admin_Api.gethnipackdetails}`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1
          },
        }
      );
      // console.log(response.data, "response");
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      if (storeResponse.status == 0) {
        setBrokrageValue(storeResponse.data)
      }
      else {
        toast.error("error")
      }

    } catch (err) {
      toast.error("Something Went Wrong")
    } finally {
    }
  }
  // console.log(brokrageValue, "brokrageValue");

  const onSubmit = (data) => {
    console.log('Form Submitted:', data);
    savePackHni(data)
  };
  const savePackHni = async (data) => {
    console.log(data, "data");
    let payloade = {
      "intraday": data.intraday,
      "delivery": data.delivery,
      "futures": data.futures,
      "options": data.options
    };
    console.log(payloade, "payloade");

    let encPayload = AESEncryption(payloade);

    try {
      const response = await axios.post(
        `${Hni_Admin_Api.inserthnipackdetail}`,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1
          },
        }
      );
      // console.log(response.data, "response");
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      console.log(storeResponse, "storeResponse");

      if (storeResponse.status == 0) {
        toast.success(storeResponse.data)
        listofhnipackdetail({ duration: selectedOption });

      } else {
        toast.error(storeResponse.message)
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 5000);
      }

    } catch (err) {
      toast.error("Something Went Wrong")
    } finally {
    }
  }
 
  const ascendingOrder = (column) => {
    const sortedList = [...hnipackList].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return a[column].localeCompare(b[column] || "");  // Sorting strings
      } else {
        return a[column] - b[column];
      }
    });
  
    setHnipackList(sortedList);
    console.log(sortedList, "ascendingItems");
  };
  
  const descendingOrder = (column) => {
    const sortedList = [...hnipackList].sort((a, b) => {
      // Handle the comparison for different data types
      if (typeof a[column] === 'string') {
        return b[column].localeCompare(a[column] || "");  // Sorting strings
      } else {
        return b[column] - a[column];  // Sorting numbers
      }
    });
  
    setHnipackList(sortedList);
    console.log(sortedList, "descendingItems");
  };

  return (
    <div className='brokerage'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='brokerage-page'>
          <div className="form-group">
            <label className="form-label">Delivery (per trades)</label>
            <select
              {...register('delivery', { required: 'Delivery is required' })}
              className={`report-custom-select brokerage-select ${errors.delivery ? 'is-invalid' : ''}`}
            >
              <option value="">Select Delivery</option>
              {brokrageValue.delivery?.map((value, index) => (
                <option key={index} value={value}>{value}</option>
              ))}
            </select>
            {errors.delivery && <span className="error-text">{errors.delivery.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Intraday (per trades)</label>
            <select
              {...register('intraday', { required: 'Intraday is required' })}
              className={`report-custom-select brokerage-select ${errors.intraday ? 'is-invalid' : ''}`}
            >
              <option value="">Select Intraday</option>
              {brokrageValue.intraday?.map((value, index) => (
                <option key={index} value={value}>{value}</option>
              ))}
            </select>
            {errors.intraday && <span className="error-text">{errors.intraday.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Futures (per contract)</label>
            <select
              {...register('futures', { required: 'Futures is required' })}
              className={`report-custom-select brokerage-select ${errors.futures ? 'is-invalid' : ''}`}
            >
              <option value="">Select Futures</option>
              {brokrageValue.futures?.map((value, index) => (
                <option key={index} value={value}>{value}</option>
              ))}
            </select>
            {errors.futures && <span className="error-text">{errors.futures.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Options (per contract)</label>
            <select
              {...register('options', { required: 'Options is required' })}
              className={`report-custom-select brokerage-select ${errors.options ? 'is-invalid' : ''}`}
            >
              <option value="">Select Options</option>
              {brokrageValue.options?.map((value, index) => (
                <option key={index} value={value}>{value}</option>
              ))}
            </select>
            {errors.options && <span className="error-text">{errors.options.message}</span>}
          </div>
        </div>

        <div className="brokerage-btn-section">
          <button type="submit" className="brokerage-save-btn" disabled={isButtonDisabled} >
            {isButtonDisabled ? "Save" : "Save"}
          </button>
        </div>
      </form>
      <div className="brokerage-table">
        <div className="btn-filter">
          <button className="dnload-btn" onClick={() => download("a")}>
            <img src={downloadbrokrage} alt="download" />
            Download All
          </button>
          <div className="form-group">
            <select
              onChange={handleDateChange}
              className="report-custom-select date-filter-brokrage"
              value={selectedOption}
            >
              <option value="CY">Current Year</option>
              <option value="TD">Today</option>
              <option value="CW">Current Week</option>
              <option value="CM">Current Month</option>
              <option value="CUSTOM">Custom</option>
            </select>
          </div>

        </div>
        <div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <table class="table">
              <thead>
                <tr>
                  <th>
                    <span className='wrap-th'>
                      <span>Sr. No</span>
                      {/* <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder()}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder()}
                        ></span>
                      </span> */}
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Delivery</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("delivery")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("delivery")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Intraday</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("intraday")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("intraday")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Futures</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("futures")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("futures")}
                        ></span>
                      </span>
                    </span></th>
                  <th><span className='wrap-th'>
                    <span>Options</span>
                    <span className='wrap-icons'>
                      <span
                        className="icon-up-triangle"
                        onClick={() => descendingOrder("options")}
                      ></span>
                      <span
                        className="icon-down-triangle"
                        onClick={() => ascendingOrder("options")}
                      ></span>
                    </span>
                  </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Day Created</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("dayCreated")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("dayCreated")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Days Left</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("daysLeft")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("daysLeft")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Status</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("status")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("status")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>In-Active Date</span>
                      <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("inActiveDate")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("inActiveDate")}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className='wrap-th'>
                      <span>Actions</span>
                      {/* <span className='wrap-icons'>
                        <span
                          className="icon-up-triangle"
                          onClick={() => descendingOrder("status")}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => ascendingOrder("status")}
                        ></span>
                      </span> */}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {hnipackList?.length > 0 ? (
                  hnipackList?.map((item, index) => (
                    <tr key={item.refId}>
                      <td>{index + 1}</td>
                      <td>{item.delivery || "-"}</td>
                      <td>{item.intraday || "-"}</td>
                      <td>{item.futures || "-"}</td>
                      <td>{item.options || "-"}</td>
                      <td>{item.dayCreated.split(" ")[0]  || "-"}</td>
                      <td>{item.daysLeft}</td>
                      {/* <td class="active-status">{item.status}</td> */}
                      <td className={item.status === "Active" ? "active-status" : "inactive-status"}>{item.status || "-"}</td>
                      <td>{item.inActiveDate.split(" ")[0] || "-"}</td>
                      {/* <td><button class="deactivate-btn"> <img src={block} alt="block" height={"10px"} width={"10px"} />Deactivate</button></td> */}
                      <td>
                        {item.status === "Active" ? (
                          <button
                            className="inactive-background inactive-status "
                            onClick={() => handleDeactivate(item)}
                          >
                            <img src={block} alt="block" height={"10px"} width={"10px"} />
                            Deactivate
                          </button>
                        ) : (<>
                          <span>-</span>
                          {/* <button
                            className="active-background active-status"
                          >
                            <img src={check} alt="check" height={"12px"} width={"12px"} />
                            Activate
                          </button> */}
                        </>)}
                      </td>
                    </tr>
                  )))
                  :
                  (<>
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  </>)}
              </tbody>
            </table>
          )}

          {/* <div class="brokerage-pagination">
            <span className='pagination-size'>Items per page</span>
            <select>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
            <span className='pagination-size'>1-10 items</span>
          </div> */}

          <div className="brokerage-pagination">
            <span className='pagination-size'>Items per page</span>
            <select className='page-select' onChange={handleItemsPerPageChange} value={itemsPerPage}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="-1">All</option>
            </select>
            <span className='pagination-size'>
              {hnipackList.length > 0
                ? `${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                  currentPage * itemsPerPage,
                  hnipackList.length
                )} of ${hnipackList.length} items`
                : "No items"}
            </span>

            {/* <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button onClick={() => handlePageChange(currentPage + 1)}>
              Next
            </button> */}
          </div>

        </div>
      </div>
      <Modal
        show={filterModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rm-model filter-update-telecaller "
      >

        <Modal.Body>
          <div className='close-button-modal'>
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="btn-close filter-closeBtn "
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <form action="" onSubmit={handleCustomSubmit}>
            <div className='filter'>
              <h2 className='modal-header-borkrage'>Select Custom Date</h2>
              <div className='options'>
                <div className='filter-section'>
                  <div className='numberInput'>
                    <label>From date:</label>
                    <input type='date'
                      name="fromDate"
                      value={customDates.fromDate}
                      onChange={handleCustomDateChange}
                      max={CommonDate.getPreviousDay}
                    />
                    {filterErrors.fromDate && <span className="modalerror-filter">{filterErrors.fromDate.message}</span>}
                  </div>
                  <div className='numberInput'>
                    <label>To date:</label>
                    <input type='date'
                      name="toDate"
                      value={customDates.toDate}
                      onChange={handleCustomDateChange}
                      max={CommonDate.toDateMax}
                    />
                    {filterErrors.toDate && <span className="modalerror-filter">{filterErrors.toDate.message}</span>}
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-btn brokerage-filter">
              <Button
                type='submit'
                className="apply"
              // closeButton
              // onClick={() => setFilterModal(false)}
              >
                Search
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default SocialMediaBrokerage;